export const BankAccountOwnerType = {
  Company: "company",
  Worker: "worker",
  CustomerAccount: "customer_account",
} as const;

export type BankAccountOwnerType =
  (typeof BankAccountOwnerType)[keyof typeof BankAccountOwnerType];
